import EnhancedDisplayBuilder from './EnhancedDisplayBuilder/EnhancedDisplayBuilder';

const EnhancedDisplayBuilderDirective = (
  reactDirective,
  CreativeService,
  RenderService
) => {
  return reactDirective(
    EnhancedDisplayBuilder,
    undefined,
    {
      restrict: 'E'
    },
    {
      CreativeService,
      RenderService
    }
  );
};

EnhancedDisplayBuilderDirective.$inject = [
  'reactDirective',
  'CreativeService',
  'RenderService'
];

export default EnhancedDisplayBuilderDirective;
